import React, { useState } from 'react';
import icons from '../../assets/icons';
import styles from './UploadFile.module.scss';
import { useDropzone } from 'react-dropzone';
import { ACCEPTABLE_IMAGE_TYPE_REQUEST, ALLOWED_MIME_TYPES } from '../../constants/constants';
import { checkFileTypes } from '../../screens/Requests/Sections/helper';
import cx from 'classnames';
import { removeExifFromImage, removeExifFromMultipleFiles } from '../../helpers/jsHelper';

function UploadFile({
  id,
  itemID = '',
  title,
  className,
  subClassName,
  subtitle = 'Drag an image here',
  uploadText = 'Upload from your device',
  acceptMutipleFiles = false,
  onFileChange,
  allowed_files = ACCEPTABLE_IMAGE_TYPE_REQUEST,
  allowedFileErrorMessage = 'Only images are allowed',
  children,
  hideIcon,
  hideUploadText,
  hidden,
  style,
  allowAllFiles = false,
  hideSubtitle = false,
  isDefault = false,
}) {
  const { RequestFileUploadIcon } = icons;

  const { getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } = useDropzone({
    onDrop: (acceptedFiles) => {
      if (allowAllFiles) handleFileChange(acceptedFiles);
      else if (checkFileTypes(acceptedFiles, allowed_files, allowedFileErrorMessage)) {
        handleFileChange(acceptedFiles);
      }
    },
  });

  const handleFileChange = async (file) => {
    const files = acceptMutipleFiles
      ? await removeExifFromMultipleFiles(file)
      : await removeExifFromImage(file[0]);
    if (onFileChange) {
      onFileChange(files, title, (itemID = itemID), isDefault);
    }
  };

  return (
    <div className={className} hidden={hidden} style={style}>
      <div
        className={cx(styles.wrapper, children && styles.noborder, subClassName)}
        {...getRootProps()}>
        {!children && (
          <>
            {!hideIcon && <RequestFileUploadIcon />}
            <span className={styles.title}>{title}</span>
            {!hideSubtitle && <span className={styles.subTitle}>{subtitle}</span>}
            {!hideUploadText && <span className={styles.uploadText}>{uploadText}</span>}
          </>
        )}
        {acceptMutipleFiles ? (
          <input key={id} id={`file-upload ${id}`} type="file" {...getInputProps()} multiple />
        ) : (
          <input key={id} id={`file-upload ${id}`} type="file" {...getInputProps()} />
        )}
        {children}
      </div>
    </div>
  );
}

export default UploadFile;
